<template>
  <div
    class="tw-flex tw-items-center tw-leading-5 tw-tracking-normal"
    :class="isValid ? 'tw-text-universal' : 'tw-text-gray-dark'"
  >
    <icon-checkbox-sm v-if="isValid" />
    <icon-checkbox-empty-sm v-else />
    <div class="tw-ml-2">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordValidationRule',
  props: {
    isValid: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
</script>
